import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPlus, FaMinus } from 'react-icons/fa';
import imgfaq from '../../assets/images/faq.jpg';
const FaqPage = () => {
    const [expanded, setExpanded] = useState(null);

    const faqData = [
        {
            question: "How can I place an order?",
            answer: "You can do so by filling out the “Contact Us” form on our homepage."
        },
        {
            question: "Do you offer any discounts for larger orders?",
            answer: "For larger orders, we provide various volume discounts."
        },
        {
            question: "Which payment methods do you accept?",
            answer: "Our customers are wholesale buyers, so payment for the goods is usually made through bank transfer."
        },
        {
            question: "Can I cancel or modify my order after it has been placed?",
            answer: "We understand that things can change and we want to provide our customers with the flexibility to adjust orders if necessary. If you need to make any changes to an order you have already placed, please do not hesitate to contact our customer service team. We will be happy to assist you and find the best solution possible, depending on the current status of your order."
        },
        {
            question: "Do you offer warranties for your products?",
            answer: "We do offer warranties on all of our products in order to ensure customer satisfaction. The length and terms of these warranties may vary depending on the specific product, so please refer to the product description or contact our customer service team for more information."
        },
        {
            question: "What should I do if I receive a damaged product?",
            answer: "If you receive a product that is damaged, there are a few things you can do. First, check the warranty information for the product to see if it covers any damages. If it does, you should contact the seller or manufacturer and explain the situation. They may be able to offer a replacement or repair the item for free. Alternatively, if the product was damaged during shipping, you may have an option for a refund or a replacement. Check the shipping company's policy to see what their options are. If possible, take photos or video of the damaged item to prove your case. Remember, it's important to keep all receipts and documentation related to the purchase and delivery of the product. This will help you in case of any disputes or issues down the road."
        }
    ];

    const handleToggle = (index) => {
        setExpanded(expanded === index ? null : index);
    };

    return (
        <div className='FaqPage'>
            <img src={imgfaq} />
            <h1>Frequently Asked Questions</h1>
            {faqData.map((item, index) => (
                <div key={index} className="faq-item" style={{ marginBottom: '10px' }}>
                    <h2 
                        onClick={() => handleToggle(index)} 
                        style={{ cursor: 'pointer', margin: 0, display: 'flex', alignItems: 'center' }}
                    >
                        {expanded === index ? <FaMinus /> : <FaPlus />} 
                        <span style={{ marginLeft: '10px' }}>{item.question}</span>
                    </h2>
                    <AnimatePresence initial={false}>
                        {expanded === index && (
                            <motion.div 
                                initial={{ height: 0, opacity: 0 }}
                                animate={{ height: 'auto', opacity: 1 }}
                                exit={{ height: 0, opacity: 0 }}
                                transition={{ duration: 0.3 }}
                                style={{ overflow: 'hidden' }}
                            >
                                <p>{item.answer}</p>
                            </motion.div>
                        )}
                    </AnimatePresence>
                </div>
            ))}
        </div>
    );
};

export default FaqPage;
